import React from "react"

export default function Footer({
    setCurrentPage
}) {
    const infoArray = [
        '법인명(상호): 하나 C&G 487-911', '대표자(성명): 윤기정', '사업자 등록번호 안내: [219-03-76425]',
        '통신판매업 신고  제 2010-경기포천-1497호'
    ]
    const contactArray = [
        '전화: 031-531-8803', '팩스: 031-531-8825', '주소: 경기 포천시 신북면 청신로 2082번길 26'
    ]

    return (
        <div
            style={{
                width: '90%',
                paddingTop: '1rem',
                marginLeft: 'auto',
                marginRight: 'auto',                
            }}
        >                    
            <div
                style={{                    
                    height: '0.1rem',
                    background: '#e9ecef'
                }}
            />
            <div
                style={{
                    marginLeft: '1rem',
                    paddingTop: '1rem',
                    display: 'flex',
                    flexDirection: 'row',                    
                    color: '#999',
                    fontSize: '0.8rem'                     
                }}    
            >
                {
                    infoArray.map((value, i) => {
                        return (
                            <div 
                                key={i}
                                style={{
                                    display: 'inline-block',           
                                    position: 'relative',
                                    paddingRight: '1.3rem'
                                }}
                            >
                                {value}
                            </div>
                        )        
                    })    
                }                            
            </div>
            <div
                style={{     
                    marginLeft: '1rem',
                    paddingTop: '0.2rem',               
                    display: 'flex',
                    flexDirection: 'row',                    
                    color: '#999',
                    fontSize: '0.8rem'                     
                }}    
            >
                {
                    contactArray.map((value, i) => {
                        return (
                            <div 
                                key={i}
                                style={{
                                    display: 'inline-block',           
                                    position: 'relative',
                                    paddingRight: '1.3rem'
                                }}
                            >
                                {value}
                            </div>
                        )        
                    })    
                }                            
            </div>
            <div
                style={{
                    marginLeft: '1rem',
                    paddingTop: '0.2rem',
                    color: '#999',
                    fontSize: '0.8rem'  
                }}
            >
                개인정보관리책임자: 윤기정(hanacng@hanmail.net)
            </div>
            <p
                style={{
                    marginLeft: '1rem',
                    color: '#999',
                    fontSize: '0.8rem'
                }}>
                Copyright &#169; 2020 <strong>하나씨앤지</strong> All rights reserved.
            </p>
        </div>
    )
}